module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/backstage-module/components/narrow-report-chart/narrow-report-chart.component.scss
// module id = ./src/app/modules/backstage-module/components/narrow-report-chart/narrow-report-chart.component.scss
// module chunks = 9